import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "background-video-player-outbox" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]

import { ref, onMounted, watch, computed, nextTick } from "vue"
import { fabric } from 'fabric';
import { deepCopy } from "@/utils/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  resolution: {
    type: String,
    default: "1920x1080"
  },
  backgroundUrl: {
    type: String,
    default: ""
    // default: "https://digital-human-1323112199.cos.ap-guangzhou.myqcloud.com/ai-virtual-man/20240428215443541393231446085.png"
  },
  backgroundColor: {
    type: String,
    default: "#fff"
  },
  backgroundVideoUrl: {
    type: String,
    default: ""
    // default: "https://videomaker-resources.ivh.qq.com/broadcast/Basic/video/c2de33b2e110494a86d56e5961e3dfe2.mp4"
  },
  logoParams: {
    type: Array,
    default: () => []
  },
  digitalman: {
    type: Object,
    default: () => ({})
  }
},
  emits: ["update:digitalman"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit

const props = __props


const digitalmanPanel = ref<HTMLDivElement | null>(null)
let canvasZoomRatio = 0

const canvasWidth = ref(0)
const canvasHeight = ref(0)
const digitalmanPanelCanvas = ref<HTMLCanvasElement | null>(null)
let canvas: fabric.Canvas = null

const customContextMenu = ref<HTMLUListElement | null>(null)

const videoWidth = ref(0)
const videoHeight = ref(0)

const preloadUrl = ref("")
const fullWidth = computed(() => {
  return canvasWidth.value / videoWidth.value > canvasHeight.value / videoHeight.value
})

const SELECT_ITEM_TYPE = {
  DIGITALMAN: 'digitalman',
  LOGO: 'logo'
}

let digitalmanRef: any = null

const loadingBackground = ref(false)
const loadingLogo = ref(0)
const loadingDigitalman = ref(false)

const loadingResource = computed(() => loadingBackground.value || loadingLogo.value > 0 || loadingDigitalman.value)

const contextShow = ref(false);
let selectedTarget: fabric.Object = null;
let selectedTargetObj: Record<string, any> | null = null;
const selectedTargetType = ref("");
const copyItem = ref<fabric.Object | null>(null);
const menuInside = ref(false);
let contextPosition = { x: 0, y: 0 }

const CONTEXT_KEYS = {
  COPY: 1,
  PASTE: 2,
  DELETE: 3
}
const contextmenus = computed(() => {
  const menuList = [
    { label: '复制', value: CONTEXT_KEYS.COPY, disabled: false },
    { label: '粘贴', value: CONTEXT_KEYS.PASTE, disabled: false },
    { label: '删除', value: CONTEXT_KEYS.DELETE, disabled: false },
  ]

  // 选择对象是数字人或没有选择对象、或是右键菜单不在对象中间时，不允许复制
  if (selectedTargetType.value === 'digitalman' || !selectedTarget || !menuInside.value)
    menuList[0].disabled = true
  // 没有复制对象时，不允许粘贴
  if (!copyItem.value)
    menuList[1].disabled = true
  // 没有选择对象、或是右键菜单不在对象中间时，不允许删除
  if (!selectedTarget || !menuInside.value)
    menuList[2].disabled = true

  return menuList
});

// 右键菜单处理方法
const contextHanlders = {
  // 复制
  [CONTEXT_KEYS.COPY]: () => {
    if (selectedTarget && selectedTargetObj)
      copyItem.value = { ...selectedTargetObj }
  },
  // 粘贴
  [CONTEXT_KEYS.PASTE]: () => {
    if (copyItem.value) {
      addLogo({
        ...copyItem.value,
        left: contextPosition.x,
        top: contextPosition.y,
        id: ""
      });
      canvas.discardActiveObject();
      copyItem.value = null;
    }
  },
  // 删除
  [CONTEXT_KEYS.DELETE]: () => {
    if (selectedTarget) {
      if (selectedTargetType.value === SELECT_ITEM_TYPE.DIGITALMAN) {
        emits("update:digitalman", {});
      } else if (selectedTargetType.value === SELECT_ITEM_TYPE.LOGO) {
        const targetIdx = props.logoParams.findIndex((item: any) => item?.id === selectedTargetObj?.id)
        if (targetIdx >= 0) props.logoParams.splice(targetIdx, 1)
        canvas.remove(selectedTarget);
      }
      selectedTarget = null;
      selectedTargetObj = null;
      selectedTargetType.value = "";
    }
  }
};

const redrawData = () => {
  // 重绘背景图
  drawBackground()
  // 重绘数字人 
  let { poseImage, left, top, width, height } = props.digitalman
  left = Math.max(Math.min(left, canvasWidth.value / canvasZoomRatio - width), 0)
  top = Math.max(Math.min(top, canvasHeight.value / canvasZoomRatio - height), 0)
  drawDigitalman({ poseImage, left, top, height })

  const logos = [...props.logoParams]
  props.logoParams.splice(0, props.logoParams.length)

  // 重绘logo
  logos.forEach((item: any) => {
    // 将logo调整到画布中 
    let { url, left, top, width, height, scaleX } = item
    const scale = scaleX * canvasZoomRatio
    left = Math.max(Math.min(left, canvasWidth.value / canvasZoomRatio - width), 0) * canvasZoomRatio
    top = Math.max(Math.min(top, canvasHeight.value / canvasZoomRatio - height), 0) * canvasZoomRatio
    addLogo({ url, left, top, scale })
  })
}

const updateCanvasResolution = () => {
  const [width, height] = props.resolution.split("x") || ["1920", "1080"];
  const { clientHeight: outboxHeight = 1, clientWidth: outboxWidth = 1 } = digitalmanPanel.value || {}
  canvasZoomRatio = Math.min(outboxWidth / parseInt(width), outboxHeight / parseInt(height))
  canvasWidth.value = parseInt(width) * canvasZoomRatio
  canvasHeight.value = parseInt(height) * canvasZoomRatio
  resizeCanvas()
  redrawData()
}

const resizeCanvas = () => {
  if (canvas) canvas.dispose()
  canvas = new fabric.Canvas(digitalmanPanelCanvas.value, {
    width: canvasWidth.value, // 画布宽度
    height: canvasHeight.value, // 画布高度
    stopContextMenu: true,
    controlsAboveOverlay: true,
    selection: false,
    preserveObjectStacking: true, // 保持对象堆叠顺序，
    originX: 'center',
    originY: 'center',
    backgroundColor: props.backgroundColor,
  });
  canvas.hoverCursor = 'pointer';

  // 右键菜单
  canvas.upperCanvasEl.oncontextmenu = (event) => {

    contextShow.value = false;
    const { offsetX, offsetY } = event;
    contextPosition = { x: offsetX, y: offsetY }
    showContextMenu(offsetX, offsetY);
    if (selectedTarget) {
      const { lineCoords } = selectedTarget;
      menuInside.value = offsetX > lineCoords.tl.x && offsetX < lineCoords.br.x && offsetY > lineCoords.tl.y && offsetY < lineCoords.br.y
    } else {
      menuInside.value = false;
    }
  };

  canvas.upperCanvasEl.onclick = () => {
    contextShow.value = false;
    contextPosition = { x: 0, y: 0 }
  };
}


const showContextMenu = (x, y) => {
  // 创建并显示右键菜单
  contextShow.value = true;
  setTimeout(() => {
    const menu = customContextMenu.value
    if (menu) {
      menu.style.left = x + 'px';
      menu.style.top = y + 'px';
    }
  }, 0);
};

// 绘制背景
const drawBackground = () => {
  canvas?.setBackgroundColor(null, canvas.renderAll.bind(canvas));
  canvas?.setBackgroundImage(null, canvas.renderAll.bind(canvas));
  if (props.backgroundUrl) {
    // 如果有 backgroundUrl 则加载背景图，拉伸背景图
    loadingBackground.value = true;
    fabric.Image.fromURL(props.backgroundUrl, (img) => {
      loadingBackground.value = false;
      img.set({
        originX: 'left',
        originY: 'top',
        scaleX: canvasWidth.value / img.width,
        scaleY: canvasHeight.value / img.height,
      });
      canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
    });
  } else if (props.backgroundColor) {
    // 如果没有 backgroundUrl 则设置背景色
    canvas?.setBackgroundColor(props.backgroundColor, canvas.renderAll.bind(canvas));
  }
}

// 绘制装饰图标
const addLogo = (imgObj: Record<string, any>,) => {
  if (!imgObj.url) return
  const imgObjCopy = deepCopy(imgObj);
  const updateLogoData = (ele) => {
    const { width, height, scaleX, scaleY, left, top, angle } = ele
    imgObjCopy.scaleX = scaleX / canvasZoomRatio
    imgObjCopy.scaleY = scaleY / canvasZoomRatio
    imgObjCopy.width = width * scaleX / canvasZoomRatio
    imgObjCopy.height = height * scaleY / canvasZoomRatio
    imgObjCopy.left = left / canvasZoomRatio
    imgObjCopy.top = top / canvasZoomRatio
    imgObjCopy.angle = angle
  }

  loadingLogo.value++;
  fabric.Image.fromURL(imgObjCopy.url, (logo) => {
    loadingLogo.value--;
    // 初始化logo数据
    logo.set({
      left: imgObjCopy.left || 20,
      top: imgObjCopy.top || 20,
      scaleX: imgObjCopy.scaleX || canvasZoomRatio,
      scaleY: imgObjCopy.scaleY || canvasZoomRatio,
      lockRotation: true,
      lockScalingFlip: true,
    })
    logo.setControlsVisibility({
      ml: false, mb: false, mr: false, mt: false, mtr: false
    });
    updateLogoData(logo)

    logo.on('modified', (e) => {
      const ele = e.target;
      if (ele) updateLogoData(ele);

    })
    logo.on("selected", (e) => {
      selectedTarget = e.target;
      selectedTargetObj = imgObjCopy
      selectedTargetType.value = SELECT_ITEM_TYPE.LOGO;
    })
    logo.on("deselected", (e) => {
      selectedTarget = null;
      selectedTargetObj = null
      selectedTargetType.value = "";
    })
    canvas.add(logo);
    if (!imgObjCopy.id) imgObjCopy.id = Math.random().toString(36).substr(2, 9)

    // 如果有这个值就证明的详情回显的
    props.logoParams.push(imgObjCopy)

  })
}


// 绘制数字人
const drawDigitalman = (digitalman: Record<string, any>) => {
  if (digitalmanRef && canvas) canvas.remove(digitalmanRef)
  if (!digitalman || !digitalman.poseImage) return
  if (loadingDigitalman.value) return
  const updateDigitalmanData = (ele) => {
    const { width, height, scaleX, scaleY, left, top, angle } = ele
    props.digitalman.scaleX = scaleX / canvasZoomRatio
    props.digitalman.scaleY = scaleY / canvasZoomRatio
    props.digitalman.width = width * scaleX / canvasZoomRatio
    props.digitalman.height = height * scaleY / canvasZoomRatio
    props.digitalman.left = left / canvasZoomRatio
    props.digitalman.top = top / canvasZoomRatio
    props.digitalman.angle = angle

  }
  loadingDigitalman.value = true
  fabric.Image.fromURL(digitalman.poseImage, (img) => {

    digitalmanRef = img
    loadingDigitalman.value = false

    // 初始缩放
    digitalmanRef.scaleToHeight(digitalman.height * canvasZoomRatio || canvasHeight.value)

    // 初始位置
    digitalmanRef.set({
      left: digitalman.left * canvasZoomRatio || canvasWidth.value / 2 - (digitalmanRef.width * digitalmanRef.scaleX) / 2,
      top: digitalman.top * canvasZoomRatio || 0
    })

    // 隐藏图像的部分控制手柄（ml, mb, mr, mt, mtr分别代表左中、下中、右中、上中和旋转手柄）
    digitalmanRef.setControlsVisibility({
      ml: false, mb: false, mr: false, mt: false, mtr: false,
    });

    updateDigitalmanData(digitalmanRef)

    digitalmanRef.on('modified', (e) => {
      const ele = e.target;
      if (ele) updateDigitalmanData(ele)
    })
    digitalmanRef.on("selected", (e) => {
      selectedTarget = e.target;
      selectedTargetObj = digitalman
      selectedTargetType.value = SELECT_ITEM_TYPE.DIGITALMAN;
    })
    digitalmanRef.on("deselected", (e) => {
      selectedTarget = null;
      selectedTargetObj = null
      selectedTargetType.value = "";
    })

    // 将图像添加到canvas中
    canvas.add(digitalmanRef);
  })
}

const clearCanvas = () => {
  props.logoParams.splice(0, props.logoParams.length)
  emits("update:digitalman", {});
  updateCanvasResolution()
}

const handleContext = (optType, disabled) => {
  if (disabled) return;
  const contextHanlder = contextHanlders[optType];
  if (contextHanlder) contextHanlder();
  contextShow.value = false;
};

const getVideoSize = (e) => {
  const { videoHeight: vh = 1, videoWidth: vw = 1 } = e.target
  videoWidth.value = vw
  videoHeight.value = vh
}


onMounted(() => {
  nextTick(() => updateCanvasResolution())
})

watch(
  () => props.resolution,
  () => { updateCanvasResolution() }
)


watch(
  () => props.backgroundVideoUrl,
  (newVal) => {
    if (newVal) {
      fetch(newVal)
        .then((response) => response.blob())
        .then((blob) => {
          // 生成Blob URL
          const blobUrl = URL.createObjectURL(blob);
          preloadUrl.value = blobUrl;
        });
    } else {
      preloadUrl.value = '';
    }
  },
  { immediate: true }
);

watch(
  () => props.backgroundUrl || props.backgroundColor,
  (newVal) => {
    drawBackground()
  }
)

watch(
  () => props.digitalman,
  (newVal, oldVal) => {
    if (newVal?.id != oldVal?.id) {
      drawDigitalman(newVal)
    }
  },
  { immediate: true, deep: true }
)


window.addEventListener("resize", () => { updateCanvasResolution() })

__expose({ addLogo, clearCanvas, getCanvas: () => canvas, getCanvasZoomRatio: () => canvasZoomRatio })

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "digitalman-panel",
    ref_key: "digitalmanPanel",
    ref: digitalmanPanel
  }, [
    _createElementVNode("div", {
      class: "digitalman-panel-content",
      style: _normalizeStyle({ width: canvasWidth.value + 'px', height: canvasHeight.value + 'px' })
    }, [
      _createElementVNode("canvas", {
        class: "digitalman-panel-canvas",
        ref_key: "digitalmanPanelCanvas",
        ref: digitalmanPanelCanvas
      }, null, 512),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("video", {
          ref: "backgroundVideoPlayer",
          class: "background-video-player",
          style: _normalizeStyle({ [fullWidth.value ? 'width' : 'height']: '100%' }),
          src: preloadUrl.value,
          controls: false,
          preload: "auto",
          onLoadeddata: getVideoSize
        }, null, 44, _hoisted_2), [
          [_vShow, preloadUrl.value]
        ])
      ]),
      _withDirectives(_createElementVNode("ul", {
        ref_key: "customContextMenu",
        ref: customContextMenu,
        class: "radius-middle"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contextmenus.value, (menu) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["radius-middle-item", { disabled: menu.disabled }]),
            key: menu.value,
            onClick: ($event: any) => (handleContext(menu.value, menu.disabled))
          }, _toDisplayString(menu.label), 11, _hoisted_3))
        }), 128))
      ], 512), [
        [_vShow, contextShow.value]
      ])
    ], 4)
  ])), [
    [_directive_loading, loadingResource.value]
  ])
}
}

})